module.exports = __webpack_public_path__ + "assets/loading.svg?82b794a2d1290a97ceccb01bb2cf66db";